import styled from "styled-components"
import {Col} from "react-bootstrap"
import {minWidthMedia} from "@irati/ui/src/global/media"

export default styled(Col)`
  margin-top: -80px;
  margin-bottom: 20px;

  ${minWidthMedia.tablet`
    margin-top: 0;
    margin-bottom: 0;
  `}
`
